import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const common: AppRouteModule = {
  path: '/common',
  name: 'Common',
  component: LAYOUT,
  meta: {
    icon: '',
    title: '详情页',
    hideMenu: true,
  },
  children: [
    {
      path: 'sleep-monitor',
      name: 'SleepMonitor',
      component: () => import('/@/views/nurse/common/sleep-monitor/index.vue'),
      meta: {
        icon: '',
        title: '睡眠看护仪',
      },
    },
    // {
    //   path: 'fall-monitor',
    //   name: 'FallMonitor',
    //   component: () => import('/@/views/nurse/common/fall-monitor/index.vue'),
    //   meta: {
    //     icon: '',
    //     title: '跌倒监测仪',
    //   },
    // },
  ],
};

export default common;
